
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, RefreshCw } from 'lucide-react';

interface PoliciesTableLoadingProps {
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export function PoliciesTableLoading({ 
  isLoading, 
  isError, 
  refetch 
}: PoliciesTableLoadingProps) {
  if (isLoading) {
    return (
      <div className="w-full py-10 flex justify-center">
        <Loader2 className="h-10 w-10 animate-spin text-muted-foreground" />
      </div>
    );
  }
  
  if (isError) {
    return (
      <div className="text-center py-10 text-red-500">
        <p>Error loading retention policies</p>
        <Button 
          variant="outline" 
          onClick={() => refetch()}
          className="mt-4"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Try Again
        </Button>
      </div>
    );
  }
  
  return null;
}
